let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cBSK5")).then(() => parcelRequire('5pzkP'));